/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const SuggestionReason = {
    Group: 'GROUP',
    Trending: 'TRENDING',
    Recent: 'RECENT'
};
export function instanceOfSuggestionReason(value) {
    for (const key in SuggestionReason) {
        if (Object.prototype.hasOwnProperty.call(SuggestionReason, key)) {
            if (SuggestionReason[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function SuggestionReasonFromJSON(json) {
    return SuggestionReasonFromJSONTyped(json, false);
}
export function SuggestionReasonFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function SuggestionReasonToJSON(value) {
    return value;
}
export function SuggestionReasonToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
